import IpubMessage from './src/main'
export default IpubMessage
